module.exports = __webpack_public_path__ + "img/patient-truck.b887b226.svg";